import { ChangeAvatarRouteContainer } from "@features/profile";

const ChangeAvatarRoute = () => {
	return (
		<>
			<ChangeAvatarRouteContainer />
		</>
	);
};

export default ChangeAvatarRoute;
